import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import MilestoneDefinitionModel from "../../../models/MilestoneDefinitionModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";
import MilestoneDefinitionControl from "../Controls/MilestoneDefinitionControl";

interface Props extends PopupProps {
    projectTypeId,
}

const CreateMilestoneDefinitionPopup: React.FC<Props> = ({ show, onHide, projectTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<MilestoneDefinitionModel|undefined>({ projectTypeId: projectTypeId } as MilestoneDefinitionModel);

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/milestoneDefinitions/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        onHide()
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'projectTypeId', label: 'Project type', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'name', label: 'Name', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'milestoneTypeId', label: 'Type', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'attachmentTypeId', label: 'Attachment type to achieve milestone', labelSize: 3 },
            { name: 'daysToAchieve', label: 'Days to achieve', labelSize: 3, validationRules: [{ type: 'isRequired' }, { type: 'isNumber' }] },
            { name: 'lateDays', label: 'Days', labelSize: 'auto', validationRules: [{ type: 'isRequiredNumber' }, { type: 'isNumber' }] },
            { name: 'lateHours', label: 'Hours', labelSize: 'auto', validationRules: [{ type: 'isNumber' }, { type: 'isMinValue', minValue: -3.5 }] },
            { name: 'lateMinutes', label: 'Minutes after milestone date', labelSize: 'auto', validationRules: [{ type: 'isNumber' }] },
            { name: 'missedDays', label: 'Days', labelSize: 'auto', validationRules: [{ type: 'isRequiredNumber' }, { type: 'isNumber' }] },
            { name: 'missedHours', label: 'Hours', labelSize: 'auto', validationRules: [{ type: 'isNumber' }] },
            { name: 'missedMinutes', label: 'Minutes after milestone date', labelSize: 'auto', validationRules: [{ type: 'isNumber' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getLabelProps, getControlProps, getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={'Create milestone'} >
            <Popup.Body>
                {formData && <MilestoneDefinitionControl getFieldProps={getFieldProps} getControlProps={getControlProps} getLabelProps={getLabelProps} formData={formData} />}
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Create' />
            </Popup.Footer>
        </Popup>
    );
}
export default CreateMilestoneDefinitionPopup;